<template>
    <div id="btn-continue" v-loading="loading" >
        <el-button v-if="text == 'Certificado'" @click="goCertificate" class="certificate" size="small">{{ text }}</el-button>    
        <el-button v-else-if="text == 'Inscribir'" @click="Inscript" class="btn-cmpc" size="small" :disabled="!block">{{ text }}</el-button>    
        <el-tag v-else-if="text == 'Reprobado'" type="danger">{{ text }}</el-tag>  
        <el-button v-else class="btn-cmpc" @click="goProgram" size="small">{{ text }}</el-button>    
    </div>
</template>

<script>
import { getInscriptionByCourse, addInscription } from '@/requests/inscriptions'
import { getLecturesByCourse } from '@/requests/lectures'
import { getCourse } from '@/requests/courses'
export default {
    props: [ 'courseId' ],
    data() {
        return {
            text: '',
            loading: false,
            block: true
        }
    },
    mounted() {
        this.loading = true
        var count = 0
        getCourse({ id: this.courseId })
        .then((respuesta)=>{

            getInscriptionByCourse({ userId: this.$session.get('userId'), courseId: this.courseId })
            .then((resp)=>{
                let inscriptions = resp.items[0]

                if(!inscriptions){
                    this.text = 'Inscribir'
                }
                else if(inscriptions.isApproved){
                    this.text = 'Certificado'
                }else{
                    getLecturesByCourse({ id: this.courseId })
                        .then((lec)=>{
                            for (let i = 0; i < lec.items.length; i++) {
                                if(lec.items[i].type == 'exam'){
                                    for (let e = 0; e < inscriptions.examTries.length; e++) {
                                        if(inscriptions.examTries[e] == lec.items[i]._id){
                                            count++
                                        }
                                        
                                    }
                                    if(count == respuesta.maxExamRetries){
                                        this.text = 'Reprobado'
                                    }else{
                                        this.text = 'Continuar'
                                    }
                                    
                                }
                                
                            }
                            //console.log('lec', lec)
                        })
                    
                    
                }
                this.loading = false
            })
        })
    },
    methods: {
        goProgram() {
            this.$router.push({ name: 'Program', params: { id: this.courseId } })
        },
        goCertificate() {
             this.$router.push({ name: 'certificates'})
        },
        Inscript() {
            this.block = false  
            addInscription(null, { courseId: this.courseId, userId: this.$session.get('userId')})
            .then((respuesta)=>{
                this.loading = false
                this.$alert('Curso inscrito!, ya puedes rendir el curso en sección "Mis cursos"', 'Inscrito', {
                    confirmButtonText: 'OK',
                    callback: action => {
                        location.reload()
                    }
                });  
            })

        }
            
        
    }
}
</script>

<style>

.certificate{
  background-color: #156D80;
  color:#fff;
  font-weight: 700;
}

.certificate:hover{
  background-color: rgb(18, 81, 95);
  color:#fff;
  font-weight: 700;
}

.certificate:focus{
  background-color: rgb(18, 81, 95);
  color:#fff;
  font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/courses/buttonContinue.vue